import { browserHistory } from 'react-router';

import { trackAction } from 'app/shared/utils/tracking';
import { CARSALE24_URL } from 'app/constants';

export const redirectToCarSale24LandingPage = (
  category: string,
  value: string,
): void => {
  trackAction('carsale24_entrypoint_click', {
    category,
    label: 'name',
    value,
  });
  if (category === 'PDP') browserHistory.push('/verkaufen?customData=pdp');
  else browserHistory.push('/verkaufen');
};

export const redirectToCarSale24 = (
  category: string,
  value: string,
  customData?: string,
): void => {
  trackAction('carsale24_button_click', {
    category,
    label: 'entrypoint',
    value,
  });
  if (customData)
    window.open(`${CARSALE24_URL}&customData=${customData}`, '_blank');
  else window.open(CARSALE24_URL, '_blank');
};

interface Ilocation {
  search: string;
}
export const generateCarsale24IframeSrc = (location: Ilocation): string => {
  const { search } = location;
  const customDataQueryParam: string =
    new URLSearchParams(search).get('customData') || '';

  // filter customData from spcial characters expect _
  const customData = customDataQueryParam.replace(/[^_ a-zA-Z 0-9]+/g, '');
  const estimateCustomData: string = customData
    ? `estimate-${customData}`
    : 'estimate';
  const iframeSrc = `https://app.carsale24.com/de-de/seller/registration/heycar?customData=${estimateCustomData}&iframe=1`;
  return iframeSrc;
};
